/** Thai strings for the game agreement (terms, privacy, cookies) and Facebook show-off pictures. */
export const SOCIAL: Record<string, string> = {
  // Rankings (ui/rankings.ts)
  Rankings: 'จัดอันดับ',
  Online: 'ออนไลน์',
  Stars: 'ดาว',
  'Fastest story': 'จบเร็วที่สุด',
  Tower: 'หอคอย',
  You: 'คุณ',
  'Loading…': 'กำลังโหลด…',
  'Trophies from public online battles. The server decides every battle.': 'ถ้วยจากการสู้ออนไลน์แบบสาธารณะ เซิร์ฟเวอร์เป็นคนตัดสินทุกการต่อสู้',
  'Story stars collected (90 is perfect: three stars on all 30 stages).': 'ดาวที่สะสมจากเนื้อเรื่อง (เต็ม 90 คือได้ 3 ดาวครบทั้ง 30 ด่าน)',
  'Time from the first story battle to finishing the last chapter. Shortest wins.': 'เวลาตั้งแต่สู้ด่านแรกจนจบบทสุดท้าย ใครใช้เวลาน้อยที่สุดชนะ',
  'Highest floor climbed in the Homework Tower.': 'ชั้นสูงสุดที่ปีนได้ในหอการบ้าน',
  'Highest hero level.': 'เลเวลฮีโร่สูงสุด',
  'Floor {n}': 'ชั้น {n}',
  '{h} h {m} min': '{h} ชม. {m} นาที',
  '{m} min': '{m} นาที',
  'Nobody is on this board yet. Be the first!': 'ยังไม่มีใครติดอันดับเลย มาเป็นคนแรกกัน!',
  'You are not on this board yet.': 'คุณยังไม่ติดอันดับในกระดานนี้',
  'Sign in to see your own place.': 'ล็อกอินเพื่อดูอันดับของตัวเอง',
  '{n} players on this board': 'มีผู้เล่นในกระดานนี้ {n} คน',
  'See all rankings →': 'ดูอันดับทั้งหมด →',
  // Quick match
  'Find an opponent!': 'หาคู่แข่งเลย!',
  "Battle someone who is looking right now. Nobody within 10 seconds? A bot 🤖 copied from a real player's hero steps in (half the trophies).": 'สุ่มเจอคนที่กำลังหาคู่อยู่ตอนนี้ ถ้าไม่มีใครภายใน 10 วินาที จะได้สู้กับบอท 🤖 ที่ก๊อปฮีโร่ของผู้เล่นจริง (ได้ถ้วยครึ่งเดียว)',
  'Looking for an opponent…': 'กำลังหาคู่แข่ง…',
  'If nobody turns up in': 'ถ้าไม่มีใครมาภายใน',
  "you battle a bot 🤖 (a copy of a real player's hero).": 'จะได้สู้กับบอท 🤖 (ร่างจำลองฮีโร่ของผู้เล่นจริง)',
  '{n} s': '{n} วินาที',
  'a bot is coming…': 'บอทกำลังมา…',
  // Battle With Friends page
  'Friends online now': 'เพื่อนที่ออนไลน์อยู่',
  'Tap Battle: they get an invite and the battle starts when they say yes.': 'กด "สู้!" เพื่อนจะได้คำชวน พอเขากดรับก็เริ่มสู้เลย',
  'None of your friends is online right now.': 'ตอนนี้ยังไม่มีเพื่อนออนไลน์',
  'No friends added yet.': 'ยังไม่ได้เพิ่มเพื่อนเลย',
  'Add friends': 'เพิ่มเพื่อน',
  'Invite with a link': 'ชวนด้วยลิงก์',
  'Make a room and send the link (LINE, Messenger…). The battle starts by itself when your friend opens it.': 'สร้างห้องแล้วส่งลิงก์ทาง LINE, Messenger ฯลฯ พอเพื่อนกดเปิดลิงก์ก็เริ่มสู้เอง',
  'Have a room code?': 'มีรหัสห้องไหม?',
  'Type the 6-letter code your friend gave you.': 'พิมพ์รหัส 6 ตัวที่เพื่อนให้มา',
  'Online battles are fair: every fighter is scaled into a {budget}-point budget, so levels cannot buy wins. Wins earn trophies.': 'การสู้ออนไลน์ยุติธรรม: ทุกตัวถูกปรับให้อยู่ในงบ {budget} แต้ม เลเวลสูงจึงไม่ได้เปรียบ ชนะแล้วได้ถ้วย',
  'Classroom room (custom rules, not ranked)': 'ห้องเรียน (ตั้งกติกาเอง ไม่นับอันดับ)',
  'Real money': 'เติมเงิน',
  'Shopping cart': 'ตะกร้าสินค้า',
  '{n} in the cart': '{n} ชิ้นในตะกร้า',
  'Empty cart': 'ล้างตะกร้า',
  'Buy all · ฿{n}': 'ซื้อทั้งหมด · ฿{n}',
  '+ Cart': '+ ใส่ตะกร้า',
  '✓ In cart': '✓ อยู่ในตะกร้า',
  'Take it out of the cart': 'เอาออกจากตะกร้า',
  'Add to the cart and pay for everything at once': 'ใส่ตะกร้าไว้ แล้วจ่ายทีเดียวทั้งหมด',
  'The cart holds up to {n} items.': 'ตะกร้าใส่ได้สูงสุด {n} ชิ้น',
  // Game agreement
  'Game agreement': 'ข้อตกลงการเล่น',
  'Before you play, please read and accept these. They explain what the game keeps and why.': 'ก่อนเริ่มเล่น กรุณาอ่านและยอมรับข้อตกลงด้านล่าง ซึ่งอธิบายว่าเกมเก็บข้อมูลอะไรบ้างและเพราะอะไร',
  'Your notebook is saved in this browser and, once you have an account, on the game server.': 'สมุดของคุณจะถูกเซฟไว้ในเบราว์เซอร์นี้ และเมื่อมีบัญชีแล้วจะเซฟบนเซิร์ฟเวอร์ของเกมด้วย',
  'We use no advertising or tracking cookies. Google sign-in and Stripe payments use their own cookies only when you choose them.':
    'เกมไม่ใช้คุกกี้โฆษณาหรือคุกกี้ติดตาม ส่วน Google (ล็อกอิน) และ Stripe (ชำระเงิน) จะใช้คุกกี้ของตัวเองเฉพาะตอนที่คุณเลือกใช้เท่านั้น',
  'Under 13? Ask a parent or guardian to read this and tick the boxes with you.': 'อายุต่ำกว่า 13 ปี? ให้พ่อแม่หรือผู้ปกครองอ่านและติ๊กยอมรับไปพร้อมกับคุณ',
  'I have read and accept the ': 'ฉันได้อ่านและยอมรับ',
  'Terms of Use': 'ข้อตกลงการใช้งาน',
  ' and the ': ' และ',
  'Privacy Policy': 'นโยบายความเป็นส่วนตัว',
  '(required)': '(จำเป็น)',
  'I allow the game to store the cookies and browser data it needs: my saved notebook, sign-in and security.': 'ฉันอนุญาตให้เกมเก็บคุกกี้และข้อมูลในเบราว์เซอร์ที่จำเป็น ได้แก่ เซฟสมุด การล็อกอิน และความปลอดภัย',
  'Accept and play': 'ยอมรับและเริ่มเล่น',
  'Tick both boxes to continue. The game cannot save without them.': 'กรุณาติ๊กทั้งสองช่องก่อนไปต่อ ถ้าไม่ยอมรับ เกมจะเซฟข้อมูลไม่ได้',

  // Show-off pictures
  'Show off on Facebook': 'อวดบน Facebook',
  'Show it off!': 'อวดเลย!',
  'My hero': 'ฮีโร่ของฉัน',
  'A monster I drew': 'มอนสเตอร์ที่ฉันวาด',
  'Level {level} · {class}': 'เลเวล {level} · {class}',
  '{n} wins · {beaten} story monsters beaten': 'ชนะ {n} ครั้ง · ผ่านมอนสเตอร์เนื้อเรื่อง {beaten} ตัว',
  'Homework Tower: floor {n}': 'หอการบ้าน: ชั้น {n}',
  'Drawn by {name}': 'วาดโดย {name}',
  'Fight it in the game with code {code}': 'มาสู้กับมันในเกมด้วยโค้ด {code}',
  'Getting your link ready…': 'กำลังเตรียมลิงก์…',
  'Your show-off picture': 'รูปอวดของคุณ',
  'The link is not ready yet.': 'ลิงก์ยังไม่พร้อม รอสักครู่นะ',
  'Share on Facebook': 'แชร์ไป Facebook',
  'Share to an app…': 'แชร์ไปแอปอื่น…',
  'Copy link': 'คัดลอกลิงก์',
  'Link copied!': 'คัดลอกลิงก์แล้ว!',
  'Save picture': 'บันทึกรูป',
  Close: 'ปิด',
  'Update Log': 'บันทึกอัปเดต',
  'Ready! Your friends will see this picture with a link to the game.': 'พร้อมแล้ว! เพื่อนจะเห็นรูปนี้พร้อมลิงก์เข้าเกม',
  'Cannot reach the game server. You can still save the picture.': 'ติดต่อเซิร์ฟเวอร์ไม่ได้ แต่ยังบันทึกรูปได้',
  'Could not make the link. You can still save the picture.': 'สร้างลิงก์ไม่ได้ แต่ยังบันทึกรูปได้',
  // Drawing rules
  "Drawing rules": "กฎการวาดรูป",
  "Keep the notebook fun for everyone. Never draw:": "ช่วยกันทำให้สมุดสนุกสำหรับทุกคน ห้ามวาด:",
  "Other players will see this drawing. It must follow the drawing rules. Never draw:": "ผู้เล่นคนอื่นจะเห็นรูปนี้ รูปต้องทำตามกฎการวาดรูป ห้ามวาด:",
  "No nudity, private body parts or anything sexual.": "ภาพโป๊ เปลือย อวัยวะเพศ หรือสิ่งที่เกี่ยวกับเรื่องทางเพศ",
  "No blood, gore or scenes meant to be truly scary or cruel.": "เลือดสาด ความรุนแรงโหดร้าย หรือภาพที่ตั้งใจให้น่ากลัวจริงจัง",
  "No hate symbols, or drawings that make fun of a religion, race, country or anyone for who they are.": "สัญลักษณ์แห่งความเกลียดชัง หรือภาพล้อเลียนศาสนา เชื้อชาติ ประเทศ หรือตัวตนของใคร",
  "No drugs, cigarettes, alcohol or gambling.": "ยาเสพติด บุหรี่ เหล้า หรือการพนัน",
  "No rude words, swearing or rude gestures written or drawn into the picture.": "คำหยาบ คำด่า หรือท่าทางหยาบคาย ทั้งที่เขียนและวาดลงในรูป",
  "No personal details: names, phone numbers, addresses, school names or social media accounts.": "ข้อมูลส่วนตัว เช่น ชื่อจริง เบอร์โทร ที่อยู่ ชื่อโรงเรียน หรือบัญชีโซเชียล",
  "No drawings that tease or bully a real person.": "ภาพล้อเลียนหรือกลั่นแกล้งคนจริงๆ",
  "No logos or characters copied from someone else's work.": "โลโก้หรือตัวละครที่ลอกมาจากผลงานของคนอื่น",
  "Drawings that break these rules are removed. Breaking them again can pause or close your account.": "รูปที่ผิดกฎจะถูกลบ ถ้าทำผิดซ้ำ บัญชีอาจถูกพักหรือปิด",
  "Got it": "เข้าใจแล้ว",
  "My drawing follows the drawing rules.": "รูปของฉันทำตามกฎการวาดรูป",
  "I agree": "ยอมรับ",
  "Tick the box to agree to the drawing rules.": "ติ๊กช่องเพื่อยอมรับกฎการวาดรูปก่อนนะ",
  // Lucky dice
  "Dice": "ลูกเต๋า",
  "Lucky dice: heal, or hurt the monster. Win 3 rounds in a row for another die.": "ลูกเต๋านำโชค: ฮีลตัวเองหรือโจมตีมอนสเตอร์ ชนะติดกัน 3 รอบจะได้ลูกเต๋าเพิ่ม",
  "Lucky dice (key D): {n} left": "ลูกเต๋านำโชค (ปุ่ม D): เหลือ {n} ลูก",
  "The die rolls off the desk. Nothing happens!": "ลูกเต๋ากลิ้งตกโต๊ะ ไม่เกิดอะไรขึ้นเลย!",
  "A sticky plaster! Heal {heal} HP.": "พลาสเตอร์ยา! ฮีล {heal} HP",
  "Paper cut! {damage} damage.": "กระดาษบาด! ทำความเสียหาย {damage}",
  "Ruler smack! {damage} damage.": "ไม้บรรทัดฟาด! ทำความเสียหาย {damage}",
  "Lucky doodle! Heal {heal} HP and deal {damage} damage.": "ดูเดิลนำโชค! ฮีล {heal} HP และทำความเสียหาย {damage}",
  "CRITICAL ROLL! {damage} damage!": "ทอยคริติคอล! ทำความเสียหาย {damage}!",
  "Bonus roll!": "ทอยโบนัส!",
  "Roll for up to double rewards.": "ทอยลุ้นรางวัลเพิ่มสูงสุด 2 เท่า",
  "Rolled {face}: +{percent}%! +{exp} EXP, +{coins} coins": "ทอยได้ {face}: +{percent}%! +{exp} EXP, +{coins} เหรียญ",
  "Rolled 1: no bonus this time.": "ทอยได้ 1: รอบนี้ไม่มีโบนัส",
  // Dice board
  "Dice board": "กระดานลูกเต๋า",
  "Start": "จุดเริ่ม",
  "Coin bag": "ถุงเหรียญ",
  "EXP": "EXP",
  "Chest": "กล่องสมบัติ",
  "Roll again": "ทอยอีกครั้ง",
  "Mystery": "ปริศนา",
  "+{n} coins!": "+{n} เหรียญ!",
  "+{n} EXP — LEVEL UP!": "+{n} EXP — เลเวลอัป!",
  "+{n} EXP!": "+{n} EXP!",
  "Roll again! +1 roll.": "ทอยอีกครั้ง! +1 สิทธิ์",
  "A board boss blocks the way!": "บอสกระดานขวางทางอยู่!",
  "A wild monster jumps out!": "มอนสเตอร์กระโดดออกมา!",
  "Shortcut! Forward {n}.": "ทางลัด! เดินหน้า {n} ช่อง",
  "Oops! Back {n}.": "อุ๊ย! ถอยหลัง {n} ช่อง",
  "Roll the die to move round the board!": "ทอยลูกเต๋าเพื่อเดินรอบกระดาน!",
  "Rolls left: {n}/{max}": "สิทธิ์ทอยเหลือ: {n}/{max}",
  "Roll!": "ทอย!",
  "Round the board! +{n} coins.": "ครบรอบกระดาน! +{n} เหรียญ",
  "Fight the boss!": "สู้กับบอส!",
  "Or keep rolling: the monster waits on its square.": "หรือทอยต่อก็ได้ มอนสเตอร์จะรออยู่ที่ช่องเดิม",
  "{n} free rolls every day, plus one for every battle you win.": "ทอยฟรีวันละ {n} ครั้ง และได้เพิ่ม 1 ครั้งทุกครั้งที่ชนะการต่อสู้",
  "Laps: {n}": "ครบรอบ: {n}",
  "Play": "เล่น",
  "Round the board!": "ครบรอบกระดาน!",
  "Back to the start: +{coins} coins.": "กลับถึงจุดเริ่ม: +{coins} เหรียญ",
  "Already at full HP — the plaster is saved for later!": "HP เต็มอยู่แล้ว เก็บพลาสเตอร์ไว้ก่อนนะ!",
  // Drawing tools
  "Bucket": "ถังสี",
  "Mirror": "กระจก",
  "Mirror (M): draw one side, the other side copies it": "กระจก (M): วาดซีกเดียว อีกซีกวาดตามให้เอง",
  "Drawing mode": "โหมดวาด",
  "Easy": "มือใหม่",
  "Pro": "มือโปร",
  "Any colour": "สีอะไรก็ได้",
  "Fine brushes and any colour you like.": "แปรงเส้นเล็กถึงใหญ่ และเลือกสีได้ทุกสี",
  "Big brushes: draw an outline, then tap the bucket inside it.": "แปรงใหญ่วาดง่าย: วาดเส้นรอบรูป แล้วจิ้มถังสีข้างในเพื่อลงสี",
  "The paint would spill out of the picture! Close the outline first, then fill inside it.": "สีจะไหลออกนอกรูป! ลากเส้นรอบรูปให้ปิดก่อน แล้วค่อยเทสีข้างใน",
  "Eyes": "ตา",
  "Mouth": "ปาก",
  "Fangs": "เขี้ยว",
  "Angry brows": "คิ้วโกรธ",
  // Move tool
  "Move": "ย้าย",
  "Select all": "เลือกทั้งหมด",
  "Delete selected": "ลบส่วนที่เลือก",
  "Press a part and drag it, or drag a box around several parts first.": "กดที่ส่วนที่วาดแล้วลากไปได้เลย หรือลากกรอบคลุมหลายส่วนก่อนแล้วค่อยย้าย",
  // Layer order
  "Layer order": "ลำดับชั้น",
  "Order": "ลำดับ",
  "Bring to front": "เอาไว้หน้าสุด",
  "Forward one": "ขยับขึ้นหน้า 1 ชั้น",
  "Back one": "ขยับไปหลัง 1 ชั้น",
  "Send to back": "ส่งไปหลังสุด",
  // Versions
  "Paper Legends v{version} is ready.": "Paper Legends เวอร์ชัน {version} พร้อมแล้ว",
  "Updated to v{version}!": "อัปเดตเป็นเวอร์ชัน {version} แล้ว!",
  // Creator page size
  "Bigger page": "ขยายหน้าวาด",
  "Smaller page": "ย่อหน้าวาด",
  "Previous stamps": "ตราปั๊มก่อนหน้า",
  // Phone drawing
  "Save": "บันทึก",
  "Turn your phone sideways for the biggest page.": "หมุนมือถือเป็นแนวนอน จะได้หน้าวาดใหญ่ที่สุด",
  // Feedback box
  "Suggest an idea": "เสนอไอเดีย",
  "💡 Suggest an idea": "💡 เสนอไอเดีย",
  "💡 An idea for the game": "💡 ไอเดียสำหรับเกม",
  "🐞 Something is broken": "🐞 เจอบัค / มีอะไรพัง",
  "💬 Something else": "💬 เรื่องอื่นๆ",
  "What is it about?": "เรื่องอะไร?",
  "What would make the game more fun? What should we add?": "อยากให้เกมมีอะไรเพิ่ม? อะไรจะทำให้เกมสนุกขึ้น?",
  "The team reads every message. Thank you for helping make Paper Legends better!": "ทีมงานอ่านทุกข้อความ ขอบคุณที่ช่วยให้ Paper Legends ดีขึ้นนะ!",
  "Please do not write your real name, phone number or address.": "อย่าเขียนชื่อจริง เบอร์โทร หรือที่อยู่ลงไปนะ",
  "Write a little more (at least {n} letters).": "เขียนเพิ่มอีกนิด (อย่างน้อย {n} ตัวอักษร)",
  "Thanks! The team got your message.": "ขอบคุณ! ทีมงานได้รับข้อความแล้ว",
  "Could not send. Try again later.": "ส่งไม่สำเร็จ ลองใหม่อีกครั้งนะ",
  "Tell the team what you would like in the game, or a bug you found.": "บอกทีมงานว่าอยากให้เกมมีอะไร หรือเจอบัคตรงไหน",
};
